import React from 'react';

import { ImageBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { FilestackImage } from 'components/Image';
import { Body, BodySmall, H2 } from 'components/Text';
import { TrackedConditionalLink } from 'components/TrackedLink';

type Props = {
  data: ImageBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function AmpImageBlock({
  data: { headline, subtitle, image, url },
  blockIndex,
  pageUpdated,
}: Props) {
  const { caption, altText } = image;

  return (
    <Box as="figure" m={0} w={1}>
      {(headline || subtitle) && (
        <Box as="figcaption" mb={48}>
          {headline && <H2>{headline}</H2>}
          {subtitle && (
            <Body
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}

      <Box as={headline || subtitle ? 'figure' : 'div'} m={0}>
        {/* @ts-expect-error ts-migrate(2786) FIXME: 'TrackedConditionalLink' cannot be used as a JSX c... Remove this comment to see the full error message */}
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated,
          }}
        >
          <FilestackImage
            data={image}
            alt={altText || ''}
            ampLeftPosition="0"
            ampTopPosition="50%"
            ampHeight={450}
            height={450}
            width={1152}
            layout="fill"
          />
        </TrackedConditionalLink>

        {caption && (
          <BodySmall mt="8px" as="figcaption">
            {caption}
          </BodySmall>
        )}
      </Box>
    </Box>
  );
}
